import * as Sentry from "@sentry/react";

export function handleErrorSentry(error, type) {
    const syntheticError = Error();
    Sentry.captureException(error, {
        originalException: error,
        syntheticException: syntheticError,
        mechanism: { handled: true, type: type },
    })
}